import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPlannerDraggingTripState {
    draggingTripId: string | null;
}

const initialState: IPlannerDraggingTripState = {
    draggingTripId: null,
};

const plannerDraggingTripSlice = createSlice({
    name: "plannerDraggingTripStore",
    initialState,
    reducers: {
        setDraggingTripId(state: IPlannerDraggingTripState, action: PayloadAction<string | null>) {
            state.draggingTripId = action.payload;
        },
    },
});

export const { setDraggingTripId } = plannerDraggingTripSlice.actions;

export default plannerDraggingTripSlice.reducer;
